import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import KitDetails from './components/KitDetails';
import Research from './components/Research';
import ResearchDetails from './components/ResearchDetails';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SpecificationsPage from './components/SpecificationsPage';
import AboutPage from './components/AboutPage';
import ComputationalThinkingPage from './components/ComputationalThinkingPage';
import ConstructionismPage from './components/ConstructionismPage';
import LearningTransferPage from './components/LearningTransferPage'
import PilotPage from './components/PilotPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Features />
              <KitDetails />
              {/* <Specifications /> */}
              <Research />
              <HowItWorks />
              <Testimonials />
              <ResearchDetails />
              <FAQ />
              {/* <CTABanner /> */}
              <Contact />
            </>
          } />
          {/* Add more routes as needed */}
          <Route path="/specifications" element={<SpecificationsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/research/computational-thinking" element={<ComputationalThinkingPage />} />
          <Route path="/research/constructionism" element={<ConstructionismPage />} />
          <Route path="/research/learning-transfer" element={<LearningTransferPage />} />
          <Route path="/pilot" element={<PilotPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;